import { CurrencyPipe, DatePipe ,DecimalPipe,Location } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, map, Observable, startWith, Subject, takeUntil, tap } from 'rxjs';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { ProductsService } from 'src/app/shared/services/products.service';
import { UserService } from 'src/app/shared/services/user.service';
import { IFactory } from 'src/core/interfaces/factory';
import { User } from 'src/core/interfaces/user';
import { environment } from 'src/environments/environment';
import { TransactionsInternalServicesService } from '../../../../../../../../src/app/shared/services/transactions-internal-services.service';
import { CustomersListComponent } from '../../shared-components/customers-list/customers-list.component';
import { ICustomer } from 'src/core/interfaces/customer';
import { ProductsListComponent } from '../../shared-components/products-list/products-list.component';
import { IProduct } from 'src/core/interfaces/product';
import Swal from 'sweetalert2';
import { SalesDeliveryStatus } from 'src/assets/static-data/enums/sales-delivery-status.enum';
import { SalesDeliveryService } from 'src/app/shared/services/sales-delivery.service';
import { ISalesDeliveryLine } from 'src/core/interfaces/ISalesDeliveryLines';
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';

@Component({
  selector: 'app-create-update-sales-delivery',
  templateUrl: './create-update-sales-delivery.component.html',
  styleUrl: './create-update-sales-delivery.component.scss',
  providers: [DatePipe,CurrencyPipe,DecimalPipe] // Provide DatePipe

})
export class CreateUpdateSalesDeliveryComponent {

  apiUrl=environment.apiURL;
  columns: TableColumn<ISalesDeliveryLine>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_CODE'),
      property: 'itemCode',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('PRODUCT_NAME'),
      property: 'itemName',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('QUANTITYREQUESTED'),
      property: 'quantityRequested',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('QUANTITYDELIVERED'),
      property: 'quantityDelivered',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT'),
      property: 'uom',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('UNIT_PRICE'),
      property: 'unitPrice',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT')+'%',
      property: 'vatPercentage',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTAL_BEFORE_VAT'),
      property: 'totalBeforeVAT',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('VAT_AMOUNT'),
      property: 'vatAmount',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('TOTALS'),
      property: 'total',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];LoadingOrderId: any;
  LoadingOrderAttachment: any;
;
  //attachmentsDataSource: MatTableDataSource<IAttachmentsSalesQuotation> | null;
  attachmentsColumns: TableColumn<any>[] = [
    {
      label: '#',
      property: 'index',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHMENT'),
      property: 'filename',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'download',
      type: 'button',
      visible: true
    },
    {
      label: this.translateService.instant('ATTACHED_BY'),
      property: 'attachedBy',
      type: 'text',
      visible: true
    },
    {
      label: this.translateService.instant('DATE_AND_TIME'),
      property: 'dateAndTime',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];;
  currentPageAttachments = 0;
  isQuotationDetails: boolean = true;
  isAttachments: boolean = false;
  allCustomers: any;
  allProducts: any;
  //dateOfToday: Date = new Date();
  factoriesList: IFactory[] = [];
  stateCtrl = new UntypedFormControl();
  stateCtrl2 = new UntypedFormControl();
  salesDeliveryForm: FormGroup;
  filteredFactories$: Observable<IFactory[]>; // Filtered list of factories
  salesMenList$: Observable<User[]>;
  salesMenList: User[] = [];
  mode:'view' = 'view';
  downloadLink: any;
  SalesDeliveryStatus = SalesDeliveryStatus; // Expose the enum to the template
  submitted:boolean=false;
  isRtl:boolean=false;
isLoading:boolean=true;
private destroy$ = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private customerService: CustomerService,
    private location: Location,
    private factoryService: FactoryService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private salesDeliveryService: SalesDeliveryService,
    private productsService: ProductsService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private salesDeliveryInternalService:TransactionsInternalServicesService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private loadingOrderService: LoadingOrderService,
  ) {
    this.salesDeliveryForm = this.fb.group({
      id: [0],
      transactionNumber: [{ value: null, disabled: true }, Validators.required],
      customerCode: [{ value: null, disabled: false }, Validators.required],
      customerName: [{ value: null, disabled: true }, Validators.required],
      customerId: [null, Validators.required],
      factoryId: [null, Validators.required],
      transactionDate: [
        {
          value: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          disabled: true
        },
        Validators.required
      ],
      status: [{ value: null, disabled: true }, Validators.required],
      salesManId: [{ value: null, disabled: true }, Validators.required],
      vatPercentage: [{ value: 0, disabled: true }, Validators.required],
      vatAmount: [{ value: 0, disabled: true }, Validators.required],
      totalBeforeVAT: [{ value: 0, disabled: true }, Validators.required],
      total: [{ value: 0, disabled: true }, Validators.required],
      custCurrentBalance: [
        { value: null, disabled: true },
        Validators.required
      ],
      custCreditLimit: [{ value: null, disabled: true }, Validators.required],
      salesDeliveryLines: this.fb.array([]),
      documentAttachments: this.fb.array([]),
      parentLoadingOrderId: [{ value: null, disabled: true }, Validators.required],
      parentSalesOrderLineId: [{ value: null, disabled: true }, Validators.required],
    });
  }

  //isLoading$=this.loadingService.isLoading$;

  ngOnInit() {
//this.loadingService.setLoading(false);
this.isRtl=this.translateService.currentLang=='ar'|| this.translateService.currentLang == 'ur'?true:false;
   
    const id = this.route.snapshot.paramMap.get('id');

    this.getAllDropDownLists().pipe(takeUntil(this.destroy$)).subscribe((res) => {

        const currentRoute = this.route.snapshot.url
          .map((segment) => segment.path)
          .join('/');
           if(currentRoute.includes('view')){
          this.mode='view';
           }
        this.salesDeliveryService
          .getSalesDeliveryById(+id).pipe(takeUntil(this.destroy$))
          .subscribe((res) => {   
            console.log("This Delivery : ", res.data.parentLoadingOrderId);
            this.LoadingOrderId = res.data.parentLoadingOrderId;

            this.loadingOrderService.getById(this.LoadingOrderId).subscribe((response) => {
              this.LoadingOrderAttachment = response.data.deliveryAuthAttachmentFilePath;
              console.log("Attachment Path",this.LoadingOrderAttachment);
             });         
            this.salesDeliveryForm.patchValue({
              id: res.data.id,
              transactionNumber: res.data.transactionNumber,
              customerCode: res.data.customerCode,
              customerName: res.data.customerName,
              customerId: res.data.customerId,
              factoryId: res.data.factoryId,
              transactionDate: this.datePipe.transform(res.data.transactionDate, 'yyyy-MM-dd HH:mm:ss') || '',
              status: this.salesDeliveryInternalService.getStatusKeyFromValue(res.data.status,2) as SalesDeliveryStatus,
              salesManId: res.data.salesManId,
              vatPercentage: res.data.vatPercentage,
              vatAmount: parseFloat(res.data.vatAmount.toFixed(4)),
              totalBeforeVAT: parseFloat(res.data.totalBeforeVAT.toFixed(4)),
              total: parseFloat(res.data.total.toFixed(4)),
              custCurrentBalance: res.data.customerCurrentBalance,
              custCreditLimit: res.data.customerCreditLimit,
              parentLoadingOrderId: res.data.parentLoadingOrderId,
              parentSalesOrderLineId: res.data.parentSalesOrderLineId,

            });
            res.data.documentAttachments.forEach((attachment: any,index: number) => {
              const attachmentGroup = this.fb.group({
                id:[attachment.id],
                filename: [attachment.filename, Validators.required],
                attachedBy: [
                  attachment.updatedBy
                    ? attachment.updatedBy
                    : attachment.createdBy,
                  Validators.required
                ],
                dateAndTime: [ this.datePipe.transform( attachment.updatedAt
                  ? attachment.updatedAt
                  : attachment.createdAt, 'yyyy-MM-dd HH:mm:ss') || ''
                 ,
                  Validators.required
                ],
                path: [attachment.path, Validators.required],
                fileContent: [attachment.path, Validators.required]
              });
              
              // Push each attachment group to the FormArray
              this.documentAttachments.push(attachmentGroup);

              this.documentAttachments.controls = [
                ...this.documentAttachments.controls
              ];
              if(this.mode=='view'){
                this.documentAttachments.at(index).disable();
              }
            });

            res.data.salesDeliveryLines.forEach(
              (lines: any, index: number) => {
                const quotationLines = this.fb.group({
                  id: [lines.id],
                  salesDeliveryId: [lines.salesDeliveryId, Validators.required],
                  parentSalesOrderLineId: [lines.parentSalesOrderLineId],
                  itemCode: [lines.itemCode, Validators.required],
                  itemName: [lines.itemName, Validators.required],
                  itemId: [lines.itemId, Validators.required],
                  quantityRequested: [lines.quantityRequested, Validators.required],
                  quantityDelivered: [lines.quantityDelivered, Validators.required],
                  uom: [lines.uom, Validators.required],
                  unitPrice: [lines.unitPrice, Validators.required],
                  total: [parseFloat(lines.total.toFixed(4)), Validators.required],
                  vatPercentage: [lines.vatPercentage, Validators.required],
                  vatAmount: [parseFloat(lines.vatAmount.toFixed(4)), Validators.required],
                  totalBeforeVAT: [parseFloat(lines.totalBeforeVat.toFixed(4)), Validators.required],
                });

                
                // Push each attachment group to the FormArray
                this.salesDeliveryLines.push(quotationLines);

                this.salesDeliveryLines.controls = [
                  ...this.salesDeliveryLines.controls
                ];

                //this.lineInputChanges(index, 'quantity');

                if(this.mode=='view'){
                  this.salesDeliveryLines.at(index).disable();
                }
                this.changeSalesDeliveryLinesNumbersCurrency(index,'unitPrice');
                this.changeSalesDeliveryLinesNumbersCurrency(index,'totalBeforeVAT');
                this.changeSalesDeliveryLinesNumbersCurrency(index,'vatAmount');
                this.changeSalesDeliveryLinesNumbersCurrency(index,'total');

                this.changeSalesDeliveryLinesNumbers(index,'quantityRequested');
                this.changeSalesDeliveryLinesNumbers(index,'quantityDelivered');
              }
            );

            

            //this.stateCtrl.setValue(res.data.factoryId?`${res.data.factoryCode} - ${res.data.factoryName}`:'');
            this.displayFactory(
              this.factoriesList.find(
                (factory) => factory.id === res.data.factoryId
              )
            );
            this.stateCtrl.setValue(
              this.factoriesList.find(
                (factory) => factory.id === res.data.factoryId
              )
            );

            this.displaySalesMan(
              this.salesMenList.find(
                (salesMan) => salesMan.id === res.data.salesManId
              )
            );
            this.stateCtrl2.setValue(
              this.salesMenList.find(
                (salesMan) => salesMan.id === res.data.salesManId
              )
            );

            if(this.mode=='view'){
              this.salesDeliveryForm.get('customerCode').disable();
              this.stateCtrl.disable();
              this.stateCtrl2.disable();

            }
          
          });

          this.isLoading=false;
      
    });

    // Filter factories based on user input
    this.filteredFactories$ = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value ? value.name : ''
      ),
      map((name) =>
        name ? this._filterList(name, 0) : this.factoriesList.slice()
      ),
      tap(() => this.salesDeliveryForm.get('factoryId').markAsTouched())
    );

    this.salesMenList$ = this.stateCtrl2.valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value ? value.userName : '')),
      map((name) => (name ? this._filterList(name, 1) : this.salesMenList.slice())),
      tap(() => this.salesDeliveryForm.get('salesManId').markAsTouched()) // Mark as touched here
    );

    this.customerService.getAllCustomers().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.allCustomers = data?.data;
    });

    this.productsService.getProducts().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.allProducts = data?.data;
    });
    
  }

  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }
  get salesDeliveryLines(): FormArray {
    return this.salesDeliveryForm.get('salesDeliveryLines') as FormArray;
  }
  get documentAttachments(): FormArray {
    return this.salesDeliveryForm.get('documentAttachments') as FormArray;
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  get visibleColumnsAttachments() {
    return this.attachmentsColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  onDownloadClick(index: number): void {
    //// // debugger;
    const uploadedFile = this.documentAttachments
      .at(index)
      .get('path').value;
    
    let url: string;
  
    if (typeof uploadedFile === 'string') {
      // If uploadedFile is a string (file path), construct the URL to the file
      // Assuming the file is served via HTTP (make sure the file is publicly accessible)
      url = `${this.apiUrl}/${uploadedFile.replace(/\\/g, '/')}`;
      // Trigger the download
    const link = document.createElement('a');
    //link.href = url;
    link.download = uploadedFile.split('/').pop() || 'download'; // Use the last part of the path as the file name
    link.click(); // Simulate the click to trigger download
    } else {
      // If uploadedFile is a Blob object, create a blob URL
      url = URL.createObjectURL(uploadedFile);
    }
  
    
  
    // If the URL is a Blob URL, clean up after the download to free up memory
    if (typeof uploadedFile !== 'string') {
      this.downloadLink = url;
      //URL.revokeObjectURL(url);
    }
  }

  changeSalesDeliveryLinesNumbersCurrency(i:number,formControl:string){
    const value=this.salesDeliveryLines.at(i).get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted = this.currencyPipe.transform(value, 'SAR', 'symbol', '1.0-4').replace('SAR', '') + ' SAR';
      this.salesDeliveryLines.at(i).get(formControl).setValue(formatted, { emitEvent: false });
    }
  }

  changeSalesDeliveryLinesNumbers(i:number,formControl:string){
    const value=this.salesDeliveryLines.at(i).get(formControl).value;
    if (value !== null && typeof value === 'number') {
      const formatted = this.decimalPipe.transform(value, '1.0-4') || '';
      this.salesDeliveryLines.at(i).get(formControl).setValue(formatted, { emitEvent: false });
    }
  }

  getFormattedNumber(index: number,formControl:string): number {
    const quantity = this.salesDeliveryLines.at(index).get(formControl).value;
    // Remove non-numeric characters except for dot and minus sign
    const cleanedValue = quantity ? parseFloat(quantity.toString().replace(/[^\d.-]/g, '')) : 0;
    return isNaN(cleanedValue) ? 0 : cleanedValue; // Ensure a valid number is returned
  }

  getDynamicWidth(index: number,formControl:string,placeholder?: string): string {
    let inputValue='';
  
    if(this.isQuotationDetails){
      inputValue = this.salesDeliveryLines.at(index).get(formControl).value;
    }else{
       inputValue = this.documentAttachments.at(index).get(formControl).value;
    }
    // Adjust according to your form structure
    // Calculate lengths based on value and placeholder
    const inputLength = inputValue ? inputValue.toString().length : 0;
    const placeholderLength = placeholder ? placeholder.length : 0;

   // Use the longer of the two lengths for width calculation
    const length = Math.max(inputLength, placeholderLength);
    // Base width and multiplier
    const baseWidth = 60;  // Minimum width in pixels
    const widthAdjustment = length * 6.8; // Each character adds 6.5px (adjust based on your font size)

    // Returning width as a string with 'px' unit
    return `${baseWidth + widthAdjustment}px`;
  }

  onBack() {
    //// // debugger;
    this.salesDeliveryForm.reset();
    this.location.back();
  }

  downloadDeliveredAttchedFile() {
    this.loadingOrderService.downloadFile(this.LoadingOrderAttachment.replace(/\\/g, '/'));
  }

  getAllDropDownLists() {
    return forkJoin({
      factories: this.factoryService.getFactories(),
      salesMen: this.userService.getSalesAgentUsersList()
    }).pipe(
      tap(({ factories, salesMen }) => {
        // Set the data for each list
        this.factoriesList = factories.data;
        this.salesMenList = salesMen.data;
      })
    );
  }

  // Display function for autocomplete
  displayFactory(factory: IFactory | null): string {
    //// // debugger;
    return factory ? `${factory.code} - ${factory.name}` : '';
  }

  displaySalesMan(salesMan: User | null): string {
    //// // debugger;
    return salesMan ? `${salesMan.userCode} - ${salesMan.userName}` : '';
  }

  ondropDownSelected(event: any, index: number) {
    if (index == 0) {
      const selectedFactory = event.option.value as IFactory;
      this.salesDeliveryForm.patchValue({
        factoryId: selectedFactory.id // Store factory ID in form control
      });
    } else {
      const selectedSalesMan = event.option.value as User;
      this.salesDeliveryForm.patchValue({
        salesManId: selectedSalesMan.id // Store factory ID in form control
      });
    }
  }

  toggleAction(quotationDetails:boolean){
    this.isQuotationDetails=quotationDetails;
    this.isAttachments=!quotationDetails;
  }

  calculateColumnSum(column: string): number {
    return this.salesDeliveryLines.controls.reduce((acc, control,index) => {
      const value = this.getFormattedNumber(index,column);
      return acc + (value ? +value : 0); // Convert value to number and add to sum
    }, 0);
  }

  private _filterList(name: string, index: number): any[] {
    //// // debugger;
    //0->factories, 1->salesMen
    const filterValue = name.toLowerCase();
    if (index == 0) {
      return this.factoriesList.filter(
        (factory) =>
          factory.name.toLowerCase().includes(filterValue) ||
          factory.code?.toLowerCase().includes(name.toLowerCase())
      );
    } else {
      return this.salesMenList.filter(
        (salesMan) =>
          salesMan.userName.toLowerCase().includes(filterValue) ||
          salesMan.userCode?.toLowerCase().includes(name.toLowerCase())
      );
    }
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  trackByPropertyAttachments<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }
}
